import { useEffect, useState } from 'react';
import dataTestids from '../constants/test-ids';
import Sidebar from '../dashboard/Sidebar';
import AppHeader from './AppHeader';

/**
 *
 * Represents the dash navbar component, as opposed to AuthedNavbar which is used on authed non-dashboard headers and will likely be replaced at some point.
 */
const AppNavigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (!isMobileMenuOpen) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsMobileMenuOpen(false);
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isMobileMenuOpen]);

  return (
    <>
      <AppHeader
        isMobileMenuOpen={isMobileMenuOpen}
        onMobileMenuToggle={() => setIsMobileMenuOpen((open) => !open)}
      />
      {isMobileMenuOpen && (
        <div
          className='md:hidden fixed left-0 right-0 bottom-0 top-16 bg-black/50 z-40'
          onClick={() => setIsMobileMenuOpen(false)}
        >
          <div
            className='h-full w-[calc(100vw-64px)] overflow-y-auto bg-white flex flex-col'
            role='dialog'
            aria-modal='true'
            aria-label='Navigation menu'
            data-testid={dataTestids.LAYOUT.HEADER.MOBILE_SIDEPANEL}
            onClick={(e) => e.stopPropagation()}
          >
            <Sidebar variant='mobile' />
          </div>
        </div>
      )}
    </>
  );
};

export default AppNavigation;
